import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewRoles = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M20 20H1.562l3.536-3.535h11.367V5.098L20 1.563V20ZM14.902 3.535H3.535v11.367L0 18.438V0h18.438l-3.536 3.535Zm-2.235 9.132H7.333V7.333h5.334v5.334Z"
    />
  </svg>
);
